import React, {useState, useEffect} from 'react'
import Select, {MultiValue, SingleValue} from 'react-select'
import {useNavigate} from 'react-router-dom'
import {get} from 'lodash'
import {FormikTouched} from 'formik'
import styles from './MultipleDropDownSelect.module.scss'

interface OptionType {
  value: any
  label: string
  id?: string // Optional: if your options have `id`
}

interface CreateNewType {
  currentPath: string
  pathTo: string
  title: string
  id?: string
}

interface MultipleDropDownSelectProps {
  firstIcon?: React.ReactNode
  options: OptionType[]
  placeholder?: string
  customClass?: string
  createNew?: CreateNewType
  value?: OptionType[] // Multi-select, so an array
  onChange?: (selected: OptionType[] | null) => void
  cancelClickFunction?: () => void
  errors?: any
  touched?: FormikTouched<{}>
  disabled?: boolean
  onBlur?: (e: any) => void
  name: string
}

const MultipleDropDownSelect: React.FC<MultipleDropDownSelectProps> = ({
  firstIcon,
  options,
  placeholder = 'Select...',
  customClass,
  createNew,
  value,
  onChange,
  cancelClickFunction,
  errors,
  touched,
  disabled = false,
  onBlur,
  name
}) => {
  const [selectedOptions, setSelectedOptions] = useState<OptionType[] | null>(
    value || []
  )
  const navigate = useNavigate()

  const hasError = get(touched, name) || ''
  const dropdownError = hasError && get(errors, name)
  useEffect(() => {
    setSelectedOptions(value || [])
  }, [value])

  const handleChange = (
    selected: MultiValue<OptionType> | SingleValue<OptionType>
  ) => {
    const selectedArray = Array.isArray(selected)
      ? selected
      : selected
      ? [selected]
      : []
    setSelectedOptions(selectedArray)
    if (onChange) {
      onChange(selectedArray)
    }
  }

  return (
    <div className={[styles.wrapper, customClass].join(' ')}>
      {/* <div className="dropdown-header">
        {firstIcon && <span className="icon">{firstIcon}</span>}
        <div className="cancel-icon" onClick={cancelClickFunction}>
          <Cancel />
        </div>
      </div> */}
      <Select
        options={options}
        isMulti
        isSearchable
        placeholder={placeholder}
        value={selectedOptions}
        onChange={handleChange}
        isDisabled={disabled}
        closeMenuOnSelect={false}
        hideSelectedOptions={false}
        onBlur={onBlur}
        name={name}
        className={styles.searchInput}
        styles={{
          control: (provided) => ({
            ...provided,
            border: dropdownError
              ? '1px solid #f8a517 !important'
              : '1px solid #e5e5e5',
            borderRadius: '10px',
            width: '104%',
            backgroundColor: dropdownError
              ? 'rgba(248, 165, 23, 0.0980387) !important'
              : '#ffffff',
            color: '#232323',
            minHeight: '49px',
            fontFamily: 'Inter',
            fontSize: '14px',
            fontWeight: 500,
            lineHeight: '17px',
            '&:hover': {
              border: '2px solid #c7d6c7',
              backgroundColor: '#f9f9f9' // hover effect
            }
          })
        }}
      />
      <div
        style={{
          color: '#f8a517',
          display: 'flex',
          justifyContent: 'flex-end',
          width: '100%',
          textAlign: 'right',
          fontSize: '12px',
          wordBreak: 'break-word',
          marginTop: '0px'
        }}
      >
        {dropdownError}
      </div>
      {createNew && (
        <div
          className={styles.temp}
          onClick={() =>
            navigate(createNew.pathTo, {
              state: {path: createNew.currentPath, id: createNew.id}
            })
          }
          style={{cursor: 'pointer', marginTop: '5px', color: 'blue'}}
        >
          + New {createNew.title}
        </div>
      )}
    </div>
  )
}

export default MultipleDropDownSelect
